import { MigrationManifest, PersistedState } from 'redux-persist'

export const migrations: MigrationManifest = {
  0: ((
    state:
      | (PersistedState & { peerPortal: { members: { columns: object } } })
      | undefined,
  ) => {
    if (!state) return state

    return {
      ...state,
      members: {
        ...state.peerPortal.members,
        columns: { ...state.peerPortal.members.columns, language: true },
      },
    }
  }) as (state: PersistedState) => PersistedState,
  1: ((
    state:
      | (PersistedState & { peerPortal: { members: { columns: object } } })
      | undefined,
  ) => {
    if (!state) return state

    return {
      ...state,
      members: {
        ...state.peerPortal.members,
        columns: {
          ...state.peerPortal.members.columns,
          lastMessageSentBy: true,
        },
      },
    }
  }) as (state: PersistedState) => PersistedState,
  2: ((
    state:
      | (PersistedState & { peerPortal: { members: { columns: object } } })
      | undefined,
  ) => {
    if (!state) return state

    return {
      ...state,
      members: {
        ...state.peerPortal.members,
        columns: {
          ...state.peerPortal.members.columns,
          lastOutreach: true,
        },
      },
    }
  }) as (state: PersistedState) => PersistedState,
  3: ((
    state:
      | (PersistedState & { peerPortal: { members: { columns: object } } })
      | undefined,
  ) => {
    if (!state) return state

    return {
      ...state,
      members: {
        ...state.peerPortal.members,
        columns: {
          ...state.peerPortal.members.columns,
          outreachCount: true,
        },
      },
    }
  }) as (state: PersistedState) => PersistedState,
  4: ((
    state:
      | (PersistedState & { peerPortal: { members: { columns: object } } })
      | undefined,
  ) => {
    if (!state) return state

    return {
      ...state,
      peerPortal: {
        ...state.peerPortal,
        members: {
          ...state.peerPortal.members,
          columns: {
            ...state.peerPortal.members.columns,
            timeZone: false,
            age: false,
            insuranceState: false,
          },
        },
      },
    }
  }) as (state: PersistedState) => PersistedState,
  5: ((
    state:
      | (PersistedState & {
          members: { columns: Record<string, boolean | undefined> }
        })
      | undefined,
  ) => {
    if (!state) return state

    const { lastMessageSentAt, ...columns } = state.members.columns

    return {
      ...state,
      members: {
        ...state.members,
        columns: {
          ...columns,
          lastMemberMessageSentAt: lastMessageSentAt ?? false,
          lastPeerMessageSentAt: false,
        },
      },
    }
  }) as (state: PersistedState) => PersistedState,
}
